import { render, staticRenderFns } from "./ModalEdit.vue?vue&type=template&id=12fcd650&scoped=true"
import script from "./ModalEdit.vue?vue&type=script&lang=js"
export * from "./ModalEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalEdit.vue?vue&type=style&index=0&id=12fcd650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fcd650",
  null
  
)

export default component.exports